const { addDocumentDelegatedListener } = require('../common/utils/domEvents');

function listenClose() {
  addDocumentDelegatedListener('click',
    '.dialog-modal__close',
    (event) => {
      const closeElement = event.target;
      const dialogElement = closeElement.closest('.dialog-modal');
      if (dialogElement.classList.contains('dialog-modal--no-close')) {
        return;
      }
      dialogElement.close();
    });

  // Close modal when clicking outside of it
  addDocumentDelegatedListener('click',
    '.dialog-modal',
    (event) => {
      const eventTarget = event.target;
      const dialogElement = eventTarget.closest('.dialog-modal');
      if (eventTarget !== dialogElement // Avoid closing modal when clicking any inside element
        || dialogElement.classList.contains('dialog-modal--no-close')
      ) {
        return;
      }

      const rect = dialogElement.getBoundingClientRect();
      const isInDialog = (rect.top <= event.clientY
        && event.clientY <= rect.top + rect.height
        && rect.left <= event.clientX
        && event.clientX <= rect.left + rect.width);
      if (!isInDialog) {
        dialogElement.close();
      }
    });

  addDocumentDelegatedListener('keydown',
    '.dialog-modal',
    (event) => {
      if (event.key !== 'Escape') {
        return;
      }

      const eventTarget = event.target;
      const dialogElement = eventTarget.closest('.dialog-modal');
      // Avoid closing modal with ESC key when it is in no-close mode
      if (dialogElement?.classList.contains('dialog-modal--no-close')) {
        event.preventDefault();
      }
    });
}

module.exports = {
  listenClose,
};
